import { useMutation, useQuery } from "react-query";
import { createStudentDocument } from "../../services/school/student/createStudent";
import { useNavigate } from "react-router-dom";
import { DocumentTypeEnum, PaymentTypeEnum, StateEnum, StudentDocumentType } from "../../types/Student";
import { Controller, useForm } from "react-hook-form";
import { routes } from "../../routes";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Card, Flex, Button, Spinner, Box, Text } from "@radix-ui/themes";
import toast from "react-hot-toast";
import { DragAndDropFileUpload } from "../../components/inputs/FileUpload/DragAndDropFileUpload";
import SelectComponent from "../../components/inputs/Select/SelectComponent";
import RadioGroupComponent from "../../components/inputs/RadioGroup/RadioGroupComponent";
import { useSelector } from "react-redux";
import { useGetTeacheIdByUserId } from "../../hooks/useGetTeacheIdByUserId";
import { RootState } from "../../redux/store";
import { getFile } from "../../utils/fileUtils";
import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { resetStudentData, setStudentData } from "../../redux/slices/school/student";
import { resetUserData, setUserData } from "../../redux/slices/users/user";
import { getStudentByCode, getStudentById, getStudentCoursesByStudentId } from "../../services/school/student/getStudentByCode";
import { getUserById } from "../../services/user/getUsers";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { UserPreview } from "../Users/UserPreview";
import { useAppDispatch } from "../../hooks/hooks";
import { CourseType } from "../../types/Course";
import { stringToBoolean } from "../../utils/utilities";
import { useGetSchoolBankConfigQuery } from "../../hooks/useGetSchoolBankConfigQuery";
import { useGetPaymentTypesQuery } from "../../hooks/useGetPaymentTypesQuery";
import { createStudentDebt, getStudentDebt } from "../../services/finance/studentDebt";
import { PaymentReferenceType, PaymentTransactionType, StudentDebtType } from "../../types/Finance";
import { createPaymentReference, getReferenceCodeV2 } from "../../services/finance/paymentReference";
import { createPaymentTransaction } from "../../services/finance/paymentTransaction";
import { setStudentDebtData } from "../../redux/slices/finance/studentDebt";
import { setPdfPreviewType } from "../../redux/slices/report/report";
import { setPaymentsTransactionsData } from "../../redux/slices/finance/paymentTransaction";
import { setPreviousPath } from "../../redux/slices/previousPath";
import { addDaysToDate, formatDateForInput } from "../../utils/dateFormatter";
import { removeDiacritics } from "../../utils/stringUtils";


export const CreateStudentDocument = () => {
  const mutation = useMutation({ mutationFn: createStudentDocument, mutationKey: 'createStudentDocument' });
  const mutationCreateStudentDebt = useMutation({
    mutationFn: createStudentDebt,
    mutationKey: "createStudentDebt",
  });
  const mutationSaveReferenceCode = useMutation({
    mutationFn: createPaymentReference,
    mutationKey: "createPaymentReference",
  });
  const mutationCreatePaymentTransaction = useMutation({
    mutationFn: createPaymentTransaction,
    mutationKey: "createPaymentTransaction",
  });
  const { UserId } = useSelector((state: RootState) => state.login.userData)
  const studentData = useSelector((state: RootState) => state.student)
  const [courses, setCourses] = useState<CourseType[]>([]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: schoolBankConfigsData, status: schoolBankConfigsStatus, isError: isErrorSchoolschoolBankConfigs, isLoading: isLoadingSchoolschoolBankConfigs } = useGetSchoolBankConfigQuery({ PageNumber: 1, PageSize: 400 });
  const {
    data: paymentTypesData,
    status: paymentTypesStatus,
    isError: isErrorPaymentTypes,
    isLoading: isLoadingPaymentTypes,
  } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 400 });
  const defaultValues: StudentDocumentType = {
    state: StateEnum.INITIATE,
    paymentProof: "",
    idStudent: "",
    paymentProofFile: null,
    docType: "",
    paymentMethod: "",
    isUrgent: false,
    studentCode: "",
    payment: {
      isPaymentByEntityReference: true,
      paymentProof: '',
      idBankEntity: ''
    },
    courseId: "",
    modelType: ""
  }

  const { control, handleSubmit, formState: { errors }, watch, getValues, setValue, resetField } = useForm<StudentDocumentType>
    (
      {
        //resolver: yupResolver(CreateClassroomFormValidation),
        defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );
  const handleBack = () => {
    navigate(routes.emitStudentDocuments);
  }
  const onSubmit = handleSubmit(async (data) => {
    try {
      
      data.madeBy = UserId;
      data.isUrgent = Boolean(data.isUrgent)
      data.isValid = stringToBoolean(data.payment?.isPaymentByEntityReference)
        ? false
        : true;
      data.madeDate = new Date().toISOString();
      const {level}  =courses.find(c=>c.id===data.courseId)??{};
      data.modelType =`${removeDiacritics(data.docType.toUpperCase())}_${removeDiacritics((level ?? '').toUpperCase())}`;
      data.paymentProofFile = null;
      const result = await mutation.mutateAsync(data);

      if (!result) {
        toast.error("Erro ao enviar pedido");
        return;
      }
      const amountToPay = paymentTypesData?.items?.find(pt => pt.id === data?.payment?.idPaymentTypeStudentDocument)?.amount ?? 0;
      let studentDebtData: StudentDebtType = {
        idStudent: data.idStudent!,
        fullname: `${studentData.student?.fullname}`,
        idPaymentType: `${data?.payment?.idPaymentTypeStudentDocument!}`,
        originalAmount: amountToPay,
        currentAmount: amountToPay,
        dueDate: formatDateForInput(addDaysToDate(new Date(), 30).toISOString()),
        description: `Pagamento de ${data.docType} - ${courses.find(c => c.id === data.courseId)?.description}MT`,
        idStudentDocument: result,
        isPayed: stringToBoolean(data.payment?.isPaymentByEntityReference)
          ? false
          : true,
      }
      try {
        const resultCreateStudentDebt =
          await mutationCreateStudentDebt.mutateAsync(studentDebtData);
        studentDebtData = { ...studentDebtData, id: resultCreateStudentDebt };

        if (stringToBoolean(getValues("payment.isPaymentByEntityReference"))) {
          const currentDate = new Date();
          const referenceCode = await getReferenceCodeV2({
            amount: studentDebtData.currentAmount,
            idStudent: studentDebtData.idStudent,
            idPaymentType: studentDebtData.idPaymentType,
            idStudentDebt: studentDebtData.id,
            month: (currentDate.getMonth() + 1).toString(),
            year: currentDate.getFullYear().toString(),
            description: studentDebtData.description,
            idBankEntity: data?.payment?.idBankEntity,
            entity: String(
              schoolBankConfigsData?.items.find(
                (i) => i.id === getValues("payment.idBankEntity")
              )?.bankEntity
            ),
          });
          const paymentReference: PaymentReferenceType = {
            idStudent: studentDebtData.idStudent,
            idPaymentType: studentDebtData.idPaymentType,
            amount: studentDebtData.currentAmount,
            dueDate:studentDebtData.dueDate,
            referenceCode: referenceCode,
            idStudentDebt: studentDebtData.id,
            entity: String(
              schoolBankConfigsData?.items.find(
                (i) => i.id === getValues("payment.idBankEntity")
              )?.bankEntity
            ),
            idBankEntity: data?.payment?.idBankEntity,
          };
          await mutationSaveReferenceCode.mutateAsync(paymentReference);
        } else {
          if (data.payment && data.payment.paymentProof) {
            const { base64 } = await getFile(data.payment.paymentProof);
            data.paymentProof = base64;
            const paymentTransaction: PaymentTransactionType = {
              date: new Date().toISOString(),
              idPaymentType: data.payment?.idPaymentTypeStudentDocument!,
              amountPaid: amountToPay,
              idStudent: studentDebtData.idStudent,
              paymentProof: base64,
              idStudentDebt: resultCreateStudentDebt,
              idCompleted: true,
            };
            await mutationCreatePaymentTransaction.mutateAsync(
              paymentTransaction
            );
          }
        }
      } catch (error) {
        toast.error(`Erro ao criar ${studentDebtData.isPayed ? 'Recibo' : 'Factura'} do estudante`);
        console.error(error);
      }

      toast.success("Pedido enviado ");
      dispatch(setPreviousPath(routes.emitStudentDocuments))

      if (stringToBoolean(getValues("payment.isPaymentByEntityReference"))) {
        await handlePrintInvoice(studentDebtData);
      } else {
        await handlePrintReceipt(studentDebtData);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handlePrintReceipt = async (c: StudentDebtType) => {
    if (!c.isPayed) {
      toast.error("Ainda não foi pago");
      return;
    }
    try {
      const studentDebtDataRequest = await getStudentDebt({ PageSize: 1, PageNumber: 1, Id: c.id });
      const paymentsTransactions = studentDebtDataRequest?.items
        .flatMap((sdr) => sdr.paymentTransactions || [])
        .filter((ref) => ref?.id)
        .filter((ref) => ref.status);
      const studentDebt = studentDebtDataRequest?.items.at(0)!
      try {
        const studentData = await getStudentById(studentDebt.idStudent);
        const userData = await getUserById(studentData.idUser)
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        console.error(error)
      }
      dispatch(setPaymentsTransactionsData(paymentsTransactions))
      dispatch(setStudentDebtData(studentDebt))
      dispatch(setPdfPreviewType('RECEIPT'))
      navigate(routes.pdfPreview)
    } catch (error) {
      console.error(error)
    }
  }
  const handlePrintInvoice = async (c: StudentDebtType) => {
    try {
      if (c.isPayed) {
        toast.error("Não é possivel obter cobrança paga no momento");
        return;
      }
      const studentDebtDataRequest = await getStudentDebt({ PageSize: 1, PageNumber: 1, Id: c.id });
      const paymentReferences = studentDebtDataRequest?.items
        .flatMap((sdr) => sdr.paymentReferences || [])
        .filter((ref) => ref?.id)
        .filter((ref) => !ref?.isPayed)
        .filter((ref) => ref.status);
      let studentDebt = studentDebtDataRequest?.items?.at(0)!;
      const paymentReference = paymentReferences?.find(p => p.amount === studentDebt.currentAmount);
      if (paymentReference) {
        studentDebt.entityCode = paymentReference.entity;
        studentDebt.referenceCode = paymentReference.referenceCode;
        studentDebt.bankDescription = schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankDescription ?? schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankName ?? "";
        studentDebt.bankName = schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankName ?? "";
      }
      try {
        const studentData = await getStudentById(studentDebt.idStudent);
        const userData = await getUserById(studentData.idUser)
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        console.error(error)
      }
      dispatch(setStudentDebtData(studentDebt))
      dispatch(setPdfPreviewType('INVOICE'))
      navigate(routes.pdfPreview)
    } catch (error) {
      console.error(error)
    }
  }

  const { isLoading: isLoadingGetStudent, refetch: fetchStudentByCode, isError: isErrorGetStudent, error } = useQuery(
    ['getStudentByCode'],
    async () => {
      const studentCodeValue = getValues('studentCode');
      try {
        const studentData = await getStudentByCode(studentCodeValue);
        if (!studentData) return;
        setValue('idStudent', studentData.id!)
        const courses = await getStudentCoursesByStudentId(studentData.id!);
        setCourses(courses);
        const userData = await getUserById(studentData.idUser)
        if (!userData) return;
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        setCourses([]);
        toast.error(`Erro ao buscar estudante`);
      }
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  );
  const handleStudentCodeChange = useCallback(
    debounce((value: string) => {
      const trimmedValue = value.trim();
      setValue('studentCode', trimmedValue);
      if (trimmedValue.length >= 3) {
        fetchStudentByCode();
      } else {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    }, 300),
    [setValue, fetchStudentByCode]
  );
  const handleOnChangePaymentType = (e: any) => {
    const paymentType = stringToBoolean(getValues('payment.isPaymentByEntityReference'))
    if (paymentType) {
      resetField('payment.paymentProof')
    }
    if (!paymentType) {
      resetField('payment.idBankEntity')
    }
  };

  const watchPaymentType = watch('payment.isPaymentByEntityReference');

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent
            name="studentCode"
            label="Código do estudante"
            control={control}
            errors={errors}
            fieldProps={{
              placeholder: 'Digite o código do estudante',
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleStudentCodeChange(e.target.value),
              onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                e.preventDefault();
                const pastedText = e.clipboardData.getData('text');
                handleStudentCodeChange(pastedText);
              }
            }}
          />
          <UserPreview />
          <SelectComponent
            name="docType"
            label="Tipo de documento que requisita"
            control={control}
            errors={errors}
            options={[
              { value: DocumentTypeEnum.DECLARACAO, label: "Declaração" },
              { value: DocumentTypeEnum.CERTIFICADO, label: "Certificado" },
              { value: DocumentTypeEnum.DIPLOMA, label: "Diploma" },
              { value: DocumentTypeEnum.CREDENCIAL, label: "Credencial" },
            ]}
            required={true}
          />
          <SelectComponent
            name="courseId"
            label="Cursos"
            control={control}
            errors={errors}
            required={true}
            options={courses.map((course) => ({
              value: course.id,
              label: course.name
            }))}
          />
          <RadioGroupComponent name="payment.isPaymentByEntityReference" label="Tipo de emolumento" control={control} errors={errors}
            style={{ width: '50%' }}
            options={[
              { value: "true", label: "Entidade Referencia" }
              , { value: "false", label: "Comprovativo" }]}
            fieldProps={{
              style: { display: 'flex', flexDirection: 'row', gap: '16px' },
              onChange: handleOnChangePaymentType
            }}
          />
          <SelectComponent
            name="payment.idPaymentTypeStudentDocument"
            label="Tipo de emolumento"
            control={control}
            errors={errors}
            itemsLoading={isLoadingPaymentTypes}
            itemsError={isErrorPaymentTypes}
            required={true}
            options={
              paymentTypesData?.items
                .map((item) => ({
                  value: item.id!,
                  label: String(item.description!) ?? "",
                })) ?? []
            }
            style={{ width: "100%" }}
          />
          <SelectComponent
            name="payment.idBankEntity"
            label="Entidade Bancária"
            control={control}
            errors={errors}
            itemsLoading={isLoadingSchoolschoolBankConfigs}
            itemsError={isErrorSchoolschoolBankConfigs}
            options={schoolBankConfigsData?.items?.map(item => ({
              value: item.id!,
              label: String(item.bankEntity!) ?? "",
            })) ?? []}
            style={{ width: '100%' }}
            fieldProps={{ disabled: !stringToBoolean(watchPaymentType) }}
          />
          <Box>
            <Text as="label" size="2">Comprovativo de Pagamento</Text>
            <Controller
              name={`payment.paymentProof`}
              control={control}

              disabled={stringToBoolean(watchPaymentType)}
              render={({ field }) => (
                <DragAndDropFileUpload
                  onFileDrop={(file) => {
                    field.onChange(file);
                  }}
                  label={`Arraste ou selecione o arquivo`}
                  accept="*"
                  selectedFile={field.value}
                  isReadOnly={stringToBoolean(watchPaymentType)}
                  disabled={stringToBoolean(watchPaymentType)}
                />
              )}
            />
            {errors.payment?.paymentProof && (
              <Text color="red" size="1">{`${errors.payment.paymentProof.message}`}</Text>
            )}
          </Box>

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>

        </Flex>
      </Card>

    </form>
  )
}
